import React from 'react';

const Norway = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46188)">
      <rect width="28" height="20" rx="3" fill="#AF010D" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8 12H0V8H8V0H12V8H28V12H12V20H8V12Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33333 10.6667H0V9.33333H9.33333V0H10.6667V9.33333H28V10.6667H10.6667V20H9.33333V10.6667Z"
        fill="#1A47B8"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46188">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Norway;
